import { Button, TextButton } from '@creditornot/cb-button';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { ModalHeader, ModalFooter, ModalContent } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';
import { useLocalStorage } from 'common/hooks';
import { Typography } from 'common/typography';

import { fetchITAEnv } from './utils';

type TaxReportingInfoModalProps = {
  merchantId: string;
  onClose: () => void;
};

const StyledWoltModal = styled(WoltModal)`
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
  width: 640px;
  margin: 16px;
`;

const StyledContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
`;

const StyledLink = styled.a`
  max-width: max-content;
  align-self: flex-end;
  color: ${colors.wolt100};
  text-decoration: none;
  margin-inline-start: 8px;
`;

const Title = styled(Typography.Heading6)`
  padding-block-start: 8px;
`;

export const TaxReportingInfoModal = ({ merchantId, onClose }: TaxReportingInfoModalProps) => {
  const { itaUri, clientId, redirectUri } = fetchITAEnv();
  const [_, setMerchantId] = useLocalStorage('merchantId', '');

  return (
    <StyledWoltModal isOpen>
      <ModalHeader style={{ paddingLeft: 16 }} onCloseClick={onClose}>
        <FormattedMessage id="tax-reporting.title" />
      </ModalHeader>
      <StyledContent>
        <Typography.Body3>
          <FormattedMessage id="tax-reporting.details.message" />
        </Typography.Body3>
        <Title>
          <FormattedMessage id="tax-reporting.details.why" />
        </Title>
        <Typography.Body3>
          <FormattedMessage id="tax-reporting.details.why-details" />
        </Typography.Body3>
        <Title>
          <FormattedMessage id="tax-reporting.details.steps.title" />
        </Title>
        <Typography.Body3>
          <FormattedMessage id="tax-reporting.details.steps.step-1" />
        </Typography.Body3>
      </StyledContent>
      <ModalFooter style={{ justifyContent: 'flex-end' }}>
        <TextButton variant="grey" onClick={onClose}>
          <FormattedMessage id="tax-reporting.close-button" />
        </TextButton>
        <StyledLink
          href={`${itaUri}?response_type=code&client_id=${clientId}&scope=scope&redirect_uri=${redirectUri}`}
          rel="noreferrer"
          target="_blank"
        >
          <Button
            size="small"
            variant="primary"
            onClick={() => {
              setMerchantId(merchantId);
              onClose();
            }}
          >
            <FormattedMessage id="tax-reporting.login-button" />
          </Button>
        </StyledLink>
      </ModalFooter>
    </StyledWoltModal>
  );
};
